import React from "react";

const SnapshotCamera = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="14" height="10.64" viewBox="0 0 24 24">
			<path
				id="icon-snapshot-camera"
				d="M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H4V7h4.05l1.83-2h4.24l1.83 2H20v10zm-8-1c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1.8c1.77 0 3.2-1.43 3.2-3.2S13.77 7.8 12 7.8 8.8 9.23 8.8 11s1.43 3.2 3.2 3.2z"
				fill="#fff"
				opacity="0.5"
			/>
		</svg>
	);
};

export default SnapshotCamera;
